export type ServiceStepType = {
    stepOrder: number
    stepName: string
    stepDescription: string
    stepType: 'step' | 'category' | 'case'
    documents: {
        documentCount: string
        documentName: string
    }[]
}

export const ratingTooltipArray = ['1', '2', '3', '4', '5']

export type ServiceResultType = {
    id: string
    path: string
    title: string
    title_mg: string
}

export type CategoryResultType = {
    id: string
    path: string
    name: string
    name_mg: string
}

export type MinistryResultType = {
    id: string
    path: string
    name: string
    name_mg: string
}

export type SelectOptionType = {
    value: string | number
    label: string
}

export type FormInputRefType = {
    fieldName: string
    fieldOptions: SelectOptionType[]
}

export type SearchItemType = {
    _id: string
    _score: number
    _source: {
        title: string
        title_mg: string
        summary: string
        summary_mg: string
        serviceDescription: string
        serviceDescription_mg: string
        itemSlug: string
        itemSlug_mg: string
        path: string
        type: 'service' | 'category' | 'ministry'
    }
}

export type QuerySuggestionType = {
    score: number
    text: string
}
